module.exports = __webpack_public_path__ + "static/media/abwrks.cfe360dc.jpg";